export const severitiesMap = new Map([
  [2, { color: 'danger.0', text: 'H', fullText: 'High' }],
  [1, { color: 'warning.0', text: 'M', fullText: 'Medium' }],
  [0, { color: 'neutral.3', text: 'L', fullText: 'Low' }],
])
